import './App.less'
// import microApp from '@micro-zoe/micro-app'
import ComponentsLayouts from '@/layouts'
import { useEffect, useLayoutEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getToken } from '@/common/utils.ts'
import { SConfigProvider } from 'shj-components'
// import { getTheme } from '@/utils/common.ts'
import useGlobalStore from '@/store'
import { setThemeRoot } from '@/utils/common.ts'
import { authDict } from 'shj-utils'

function App(props) {
  const location = useLocation()
  const navigate = useNavigate()
  const theme = useGlobalStore((state: any) => state.theme)

  useLayoutEffect(() => {
    setThemeRoot(theme)
  }, [theme])

  useEffect(() => {
    if (!getToken()) {
      navigate('/login', { replace: true })
    }
    if (location.pathname === '/') {
      navigate('/main', { replace: true })
    }
  }, [location])

  const configProvider = {
    antdConfig: {
      theme: theme,
    },
    // authKeys: AuthBtnConfig
    auths: authDict,
  }

  return (
    <SConfigProvider {...configProvider}>
      <ComponentsLayouts />
    </SConfigProvider>
  )
}

export default App
